export default "__VITE_ASSET__BDqThBMh__"